<div class="dialog-header">
  <span>{{(isRefineryLevel) ? refineryInfo.name : regionInfo.padd_region }} Refinery {{ isPlanned() ? 'Planned Outatges' : 'Alerts' }}</span>
  <fa-icon icon="times" class="icon-color" (click)="dialogRef.close()"></fa-icon>
</div>

<div #content class="dialog-content">
  <div class="total-section">
    <span class="total-header">Total {{ isPlanned() ? 'Planned Outatges' : 'Alerts' }}</span>
    <span>{{ alertData.length }}</span>
  </div>

  <ng-container *ngIf="!isPlanned()" [ngTemplateOutlet]="alert"></ng-container>
  <ng-container *ngIf="isPlanned()" [ngTemplateOutlet]="planned"></ng-container>
</div>

<ng-template #alert>
  <div class="table-container">
  
    <table mat-table [dataSource]="dataSource" matSort [matSortDisableClear]="true" multiTemplateDataRows>
      <ng-container matColumnDef="fac_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Facility Name
              <eaglei-table-sort-header [columnName]="'fac_name'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.facility_name }}</td>
      </ng-container>

      <ng-container matColumnDef="unit_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="2">
              Unit Name
              <eaglei-table-sort-header [columnName]="'unit_name'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="2">
              {{ info.unit_name }}
          </td>
      </ng-container>

      <ng-container matColumnDef="unit_cat">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Unit Category
              <eaglei-table-sort-header [columnName]="'unit_cat'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.unit_category }}</td>
      </ng-container>

      <ng-container matColumnDef="prod_class">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Product Class
              <eaglei-table-sort-header [columnName]="'prod_class'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.product_class }}</td>
      </ng-container>

      <ng-container matColumnDef="dis_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Distributed Date
              <eaglei-table-sort-header [columnName]="'dis_date'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.distributed_datetime | momentDate : 'MM/DD/YYYY' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3"></th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">
            <fa-icon [icon]="info === selectedRow ? 'chevron-up' : 'chevron-down'"></fa-icon>
          </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let info" [attr.colspan]="10">
            <div class="hide-expanded-row" [class.show-expanded-row]="selectedRow === info">
              <div class="description">
                <span class="description-header">Alert Description</span>
                {{ info.description }}
              </div>  
            </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnNames()"></tr>
      <tr
          mat-row
          *matRowDef="let row; columns: columnNames(); let odd = odd"
          class="clickable"
          (click)="toggleExpandedRow(row)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-row"></tr>
    </table>

  </div>
</ng-template>

<ng-template #planned>
  <div class="table-container">
  
    <table mat-table [dataSource]="dataSource" matSort [matSortDisableClear]="true" multiTemplateDataRows>
      <ng-container matColumnDef="fac_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Facility Name
              <eaglei-table-sort-header [columnName]="'fac_name'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.name }}</td>
      </ng-container>

      <ng-container matColumnDef="unit_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="2">
              Unit Name
              <eaglei-table-sort-header [columnName]="'unit_name'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="2">
              {{ info.unit_name }}
          </td>
      </ng-container>

      <ng-container matColumnDef="outage_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Outage Type
              <eaglei-table-sort-header [columnName]="'outage_type'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.outage_type }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Status
              <eaglei-table-sort-header [columnName]="'status'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.status }}</td>
      </ng-container>

      <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
              Start Date
              <eaglei-table-sort-header [columnName]="'start_date'" [sort]="sort"></eaglei-table-sort-header>
          </th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.expected_start_date | momentDate : 'MM/DD/YYYY' }}</td>
      </ng-container>

      <ng-container matColumnDef="end_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
            End Date
            <eaglei-table-sort-header [columnName]="'end_date'" [sort]="sort"></eaglei-table-sort-header>
        </th>
        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.expected_end_date | momentDate : 'MM/DD/YYYY' }}</td>
      </ng-container>

      <ng-container matColumnDef="obser_start">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
            Observed Start Date
            <eaglei-table-sort-header [columnName]="'obser_start'" [sort]="sort"></eaglei-table-sort-header>
        </th>
        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.observed_start_date | momentDate : 'MM/DD/YYYY' }}</td>
      </ng-container>

      <ng-container matColumnDef="obser_end">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3">
            Observed End Date
            <eaglei-table-sort-header [columnName]="'obser_end'" [sort]="sort"></eaglei-table-sort-header>
        </th>
        <td mat-cell *matCellDef="let info" [attr.colspan]="3">{{ info.observed_end_date | momentDate : 'MM/DD/YYYY' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.colspan]="3"></th>
          <td mat-cell *matCellDef="let info" [attr.colspan]="3">
            <fa-icon [icon]="info === selectedRow ? 'chevron-up' : 'chevron-down'"></fa-icon>
          </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let info" [attr.colspan]="10">
            <div class="hide-expanded-row" [class.show-expanded-row]="selectedRow === info">
              <div class="description">
                <span class="description-header">Outage Description</span>
                {{ info.comments }}
                <div>
                  <span class="description-header">Last Updated:</span>
                  <div>{{info.last_updated | momentDate : 'MM/DD/YYYY hh:mm A'}}</div>
                </div>
                <div>
                  <span class="description-header">Confidence:</span>
                  <div>{{getConfidenceLabel(info.confidence_id)}}</div>
                </div>
              </div>  
            </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnNames()"></tr>
      <tr
          mat-row
          *matRowDef="let row; columns: columnNames(); let odd = odd"
          class="clickable"
          (click)="toggleExpandedRow(row)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-row"></tr>
    </table>

  </div>
</ng-template>

<div class="dialog-actions">
  <button mat-stroked-button color="primary" (click)="dialogRef.close()">Close</button>
</div>
